<div class="page-content d-flex align-items-center justify-content-center">
  <div class="card col-11 col-md-6 col-lg-4 shadow rounded p-4 border-0">
    <div class="card-body p-0">
      <h5 class="card-title text-center mb-4">
        {{ 'recover_password' | transloco }}
      </h5>

      @if (!success) {
        <form [formGroup]="restoreForm" class="w-100">
          <p class="text-center text-muted mt-3">
            {{ 'warning_restore' | transloco }}
          </p>

          <div class="mb-3">
            <app-input-phone-email formControlName="contact" />
          </div>

          <button type="button" class="btn btn-primary w-100" (click)="send()" [disabled]="restoreForm.invalid">
            {{ 'reset_password' | transloco }}
          </button>
        </form>
      } @else {
        <div class="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center">
          <i class="bi bi-check-lg text-primary display-4"></i>
          @if (resolvedPhone) {
            <p [innerHTML]="'sms_sent_info' | transloco"></p>
          } @else if (resolvedEmail) {
            <p [innerHTML]="'email_sent_info' | transloco: { email: resolvedEmail }"></p>
          }
        </div>
      }
    </div>
  </div>
</div>
